import React, {useState} from 'react';
import {Card, Col, Row} from "react-bootstrap";
import { FaArrowRightFromBracket } from "react-icons/fa6";
import {FaBook, FaBookOpen, FaCoins, FaSearch, FaUser} from "react-icons/fa";
import TakeThisAssignment from "../modals/assign/TakeThisAssignment";
import InfoAssUnderBookS2 from "../modals/book/InfoAssUnderBookS2";

// Функция для форматирования даты (месяц и день)


const AssignUnderBookS2 = ({ assign, onClick }) => {

    const  [infoS2Visible, setinfoS2Visible] = useState(false);

    const date = new Date(assign.start_read_date * 60 * 1000);

// Массив с сокращениями месяцев
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Получаем месяц, день, год, часы и минуты
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const isMobile = window.innerWidth <= 768; //


// Форматируем вывод (часы и минуты с ведущим нулем, если нужно)
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedHours = hours < 10 ? `0${hours}` : hours;


    return (
        <>
            <Card
                className="mt-0 p-0 mx-auto mb-1"
                style={{
                    borderRadius: '6px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    cursor: 'pointer',
                    height: '120px', // ✅ Фиксированная высота карточки
                    width: isMobile ? '260px' : '230px',
                }}
                onClick={() => setinfoS2Visible(true)}
                onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0px 6px 16px rgba(0, 0, 0, 0.2)';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0px 4px 12px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                <Card.Body className="d-flex flex-column position-relative py-2 px-3">
                    {/* Условный рендеринг для статуса */}
                    {assign.assignment_status === 'READING' || assign.assignment_status === 'READING_RIDT' || assign.assignment_status === 'READING_RE' ? (
                        <>
                            <div
                                className="fw-semibold mb-1 mt-0 text-muted"
                                style={{
                                    display: "block", // ✅ Заменяем `-webkit-box` на `block` для лучшего контроля
                                    maxWidth: "100%", // ✅ Заполняет всю ширину родителя
                                    overflow: "hidden",
                                    textOverflow: "ellipsis", // ✅ Обрезает в конце, а не заранее
                                    whiteSpace: "nowrap" // ✅ Чтобы работало корректно для одной строки
                                }}
                            >
                                <FaBookOpen className="me-1 text-success fa-beat" /> {/* ✅ Анимированная иконка */}
                                Participant start working...
                            </div>
                            <div className="d-flex flex-wrap gap-1">

                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaBookOpen className="me-2" />
                                    Start: <b>{`${month}-${day}`}</b> at: <b>{`${formattedHours}:${formattedMinutes}`}</b>

                                </p>


                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaBook className="me-1" /> {/* ✅ Улучшенная иконка */}
                                    Type:{" "}<b>
                                    {(() => {
                                        switch (assign.assTypeId) {
                                            case 1: return "Universal";
                                            case 2: return "Kindle Unlimited";
                                            case 3: return "Verified Purchase";
                                            case 4: return "Verified + Img";
                                            case 5: return "VP Search&Buy";
                                            case 6: return "VP Search&Buy + Img";
                                            case 7: return "Universal for Audio";
                                            case 8: return "Audible Promo Code";
                                            case 9: return "Verified Kindle Unlimited";
                                            case 10: return "PaperBack BuyOut";
                                            case 11: return "PB Search&BuyOut";
                                            case 12: return "PB Verified Pur. + Img";
                                            case 13: return "PB Verified + Video";
                                            case 14: return "HC BuyOut";
                                            case 15: return "HC Search&BuyOut";
                                            case 16: return "HC Verified Pur. + Img";
                                            case 17: return "HC Verified + Video";
                                            case 18: return "PB Verified Purchase";
                                            case 19: return "PB VP Search&Buy";
                                            case 20: return "HC Verified Purchase";
                                            case 21: return "HC VP Search&Buy";
                                            case 22: return "Product BuyOut";
                                            case 23: return "Prod. Search&BuyOut";
                                            case 24: return "Prod. Verified Pur.";
                                            case 25: return "Prod. Verified + Img";
                                            case 26: return "Prod. Verified + Vid";
                                            case 27: return "Prod. VP Search&Buy";
                                            case 28: return "Make Helpful Internal";
                                            case 29: return "Write Report Internal";
                                            case 30: return "Make Helpful External";
                                            case 31: return "Write Report External";
                                            case 32: return "Set Stars Rating";
                                            default:
                                                return "Unknown Type"; // ✅ Защита от неверных значений
                                        }
                                    })()}</b>
                                </p>
                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaCoins className="me-2" />
                                    Cost: <b>{assign.assignment_price_publisher || 'Unknown'}</b> Virt /
                                    <b className="text-danger">
                                        {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(assign?.assTypeId) ? (
                                            assign?.assignment_price_publisher
                                                ? ` $${assign.book_cost_compensation}`
                                                : "N/A"
                                        ) : (
                                            (() => {
                                                let priceLabel;
                                                switch (assign?.booksPriceId) {
                                                    case 1: priceLabel = " Free"; break;
                                                    case 2: priceLabel = " $0.99"; break;
                                                    case 3: priceLabel = " $1.99"; break;
                                                    case 4: priceLabel = " $2.99"; break;
                                                    case 5: priceLabel = " $3.99"; break;
                                                    case 6: priceLabel = " $4.99"; break;
                                                    case 7: priceLabel = " $5.99"; break;
                                                    case 8: priceLabel = " $6.99"; break;
                                                    case 9: priceLabel = " $7.99"; break;
                                                    case 10: priceLabel = " $8.99"; break;
                                                    case 11: priceLabel = " $9.99"; break;
                                                    default: priceLabel = " Unknown Type";
                                                }

                                                // Добавляем " Promo" при нужных условиях
                                                if (assign?.booksPriceId === 1 && [3, 4, 5, 6, 32].includes(assign?.assTypeId)) {
                                                    priceLabel += " Promo";
                                                }

                                                return priceLabel;
                                            })()
                                        )}
                                    </b>
                                </p>
                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaUser className="me-2" />
                                    Participant: <b>{assign.reviewer_name || 'Unknown'}</b>{assign?.rating_of_reviewer > 20 && (
                                    <span className="ms-0 fw-semibold text-success">
                                        {" "}/ Q-{assign.rating_of_reviewer}%
                                     </span>
                                )}
                                </p>

                            </div>



                        </>
                    ) : ('No new assignments')}



                </Card.Body>
            </Card>
            <InfoAssUnderBookS2
                show={infoS2Visible}
                handleClose={() => setinfoS2Visible(false)}
                assignment={assign}
                // Передаем callback для обновления данных// Передаем данные книги в модалку
            />
        </>

    );
};

export default AssignUnderBookS2;
